import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";
import { Feature } from "@/enums";

const initialState: FeatureState = {
  features: undefined,
};

const getters: GetterTree<FeatureState, RootState> = {
  active(state: FeatureState): Array<Feature> {
    if (state.features)
        return state.features.active;
    return [];
  },
  supported(state: FeatureState): Array<Feature> {
    if (state.features)
        return state.features.supported;
    return [];
  },
};

const mutations: MutationTree<FeatureState> = {
  RESET(state: FeatureState) {
    state.features = undefined;
  },

  SET_MODELS(state: FeatureState, payload: Features) {
    state.features = payload;
  },
};

const actions: ActionTree<FeatureState, RootState> = {
  reset({ commit }) {
    commit("RESET");
  },
  index({ commit, rootState, state }) {
    if (state.features) {
      return new Promise((resolve) => resolve(this.getters["feature"]));
    }

    return rootState.api
      .get(`features`)
      .then((response: { data: Features }) => {
        commit("SET_MODELS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
